<!-- Componente mejorado con UX/UI moderno -->
<nav class="navbar navbar-expand-sm navbar-light shadow-sm bg-white sticky-top">
  <div class="container-fluid d-flex justify-content-between align-items-center">
    <a class="navbar-brand fw-bold fs-3" href="#">
      <span id="burgundy">{{conf?.name?.split(' ')[0]}}</span>
      <span id="orange">{{conf?.name?.split(' ')[1]}}</span>
    </a>
    <div class="header-actions">
      <div class="input-group search-bar">
        <input [(ngModel)]="search" (keyup.enter)="getCatalogo()" type="text" class="form-control"
          placeholder="Buscar productos...">
        <button *ngIf="!proccess; else loading" (click)="getCatalogo()" class="btn btn-orange">
          <i class="fas fa-search"></i>
        </button>
        <ng-template #loading>
          <button class="btn btn-orange"><i class="fa fa-spinner spin"></i></button>
        </ng-template>
      </div>

      <div class="d-none d-sm-flex align-items-center gap-2">
        <a (click)="openModalLogin()" class="nav-link fs-5" href="javascript:void(0)"><i
            class="fas fa-user-circle"></i></a>
        <button routerLink="/user/dashboard/perfil"
          class="btn btn-orange position-relative animate__animated animate__bounceIn">
          <i class="fa fa-shopping-basket fa-lg"></i>
          <span
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger animate__animated animate__pulse animate__infinite">
            {{cantidad$ | async}}
          </span>
        </button>
      </div>
    </div>

  </div>
</nav>
<!-- Bottom Navigation Bar solo visible en móviles -->
<nav class="bottom-nav d-md-none">
  <a class="nav-item" (click)="scrollToTop()" title="Inicio">
    <i class="fas fa-home"></i>
  </a>
  <a class="nav-item" (click)="focusSearch()" title="Buscar">
    <i class="fas fa-search"></i>
  </a>
  <a class="nav-item position-relative" routerLink="/user/dashboard/perfil" title="Carrito">
    <i class="fas fa-shopping-basket"></i>
    <span
      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger animate__animated animate__pulse animate__infinite">
      {{ cantidad$ | async }}
    </span>
  </a>
  <a href="javascript:void(0)" class="nav-item" (click)="openModalLogin()" title="Cuenta">
    <i class="fas fa-user-circle"></i>
  </a>
</nav>

<div class="container-fluid py-4">
  <app-slider></app-slider>
  <div class="row mt-3">

    <aside class="col-lg-2 mb-4">
      <div class="card shadow-sm p-3 rounded-4">
        <h5 class="filtros-titulo">Filtros</h5>

        <div *ngFor="let categoria of itemsC" class="mb-2">
          <!-- Checkbox maestro categoría -->
          <div class="form-check mb-1">
            <input type="checkbox" class="form-check-input" [id]="'cat-' + categoria.id"
              [checked]="isCategoriaChecked(categoria)" [indeterminate]="isCategoriaIndeterminate(categoria)"
              (change)="toggleCategoriaCheck(categoria, $event)" />
            <label class="form-check-label filtros-subtitulo" [for]="'cat-' + categoria.id"
              (click)="toggleCategoria(categoria.id)">
              {{ categoria.nombre }}
            </label>
          </div>

          <!-- Grupos dentro -->
          <div *ngIf="categoria.expanded" class="ml-3 ps-2 border-start">
            <div class="form-check" *ngFor="let grupo of categoria.grupos">
              <input class="form-check-input" type="checkbox" [value]="grupo.id" [id]="'grupo-' + grupo.id"
                [checked]="selectedGroups.includes(grupo.id)" (change)="updateSelectedGrupo($event, categoria.id)" />
              <label class="form-check-label" [for]="'grupo-' + grupo.id">
                {{ grupo.nombre }}
              </label>
            </div>
          </div>
        </div>

      </div>
    </aside>



    <!-- Productos -->
    <section class="col-lg-10 ">
      <div class="catalog-toolbar">
        <div class="catalog-info" *ngIf="conf?.dolar">
          Viendo <span>{{ count }}</span> productos —
          Cotización Dólar:💵 <span>{{ cotizacion }}</span>
        </div>

        <div class="catalog-info" *ngIf="!conf?.dolar">
          Viendo <span>{{ count }}</span> productos
        </div>

        <div class="catalog-select">
          <select class="form-select w-auto" [(ngModel)]="limit" (change)="getCatalogo()">
            <option *ngFor="let c of limits" [ngValue]="c">{{ c }} por página</option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="proccess; then thenTemplate; else elseTemplate"></ng-container>

      <ng-template #thenTemplate>
        <app-loading></app-loading>
      </ng-template>

      <ng-template #elseTemplate>
        <div class="row g-4">
          <!-- Si no hay productos -->
          <div *ngIf="!itemsM?.length" class="col-12 text-center py-5">
            <i class="fas fa-box-open fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">No se encontraron productos</h5>
            <p class="text-muted small">Proba ajustar los filtros o la búsqueda</p>
          </div>
          <div class="col-md-6 col-lg-4" *ngFor="let item of itemsM">
            <div class="card product-card h-100 border-0 shadow-sm rounded-4" [ngClass]="{
              'card-sin-stock': item.stock <= 0,
              'card-mas-vendido': item.masVendido
            }">

              <!-- Imagen con alt para accesibilidad -->
              <div class="product-img-wrapper rounded-top-4 position-relative">
                <a href="javascript:void(0)" (click)="openModal(item)">
                  <app-image-preview [width]="isMobile ? '100%' : 'auto'" [height]="isMobile ? 'auto' : '22rem'"
                    [imgsrc]="isMobile ? (item.thumb || item.photo) : item.photo"
                    [alt]="item.nombre || 'Imagen de producto'">
                  </app-image-preview>



                  <!--

                           <app-image-preview [width]="'auto'" [height]="'22rem'" [imgsrc]="item.photo"
                    [alt]="item.nombre || 'Imagen de producto'">
                  </app-image-preview>
                    

                      -->
                </a>
                <!--
                <span *ngIf="item.masVendido" class="badge most-sold-badge-overlay" aria-label="Producto más vendido">
                  🔥 Más vendido
                </span>
              -->
              </div>
              <div class="card-body d-flex flex-column">

                <!-- Nombre con tooltip -->
                <h5 class="card-title text-truncate" [title]="item.nombre">{{ item.nombre }}</h5>

                <!-- Etiqueta Mas vendido -->
                <span *ngIf="item.masVendido" class="badge badge-success mb-2 most-sold-badge"
                  aria-label="Producto más vendido">
                  🔥 Más vendido
                </span>
                <!-- Descripción con límite de caracteres -->
                <p class="card-text text-muted" [ngClass]="{'mb-3': item.descripcion, 'mb-4': !item.descripcion}">
                  {{ item.descripcion ? (item.descripcion.length > 100 ? (item.descripcion | slice:0:100) + '...' :
                  item.descripcion) : '\u00A0' }}
                </p>

                <!-- Colores disponibles -->
                <div class="product-colors d-flex flex-wrap gap-2">
                  <div *ngFor="let color of item.colores" class="color-swatch-wrapper">
                    <div class="color-swatch" [style.backgroundColor]="color.hex" [title]="color.nombre"></div>
                    <small class="text-muted">{{ color.nombre }}</small>
                  </div>
                </div>
                <!--
<div *ngIf="item.colores?.length" class="mb-2">
                  <strong>Colores: </strong>
                  <span *ngFor="let color of item.colores; let last = last">
                    {{ color.nombre }}<span *ngIf="!last">, </span>
                  </span>
                </div>
-->
                <!-- Stock -->
                <div class="row">
                  <p class="small mb-2 col-6">
                    <i class="fas fa-box-open"></i> Stock disponible:
                    <strong>{{ item.stock ? item.stock : 0 }}</strong>
                  </p>
                  <p class="small mb-2 col-6">
                    <i class="fas fa-clock"></i> Stock pedido:
                    <strong>{{ item.ped_stock ? item.ped_stock : 0 }}</strong>
                  </p>
                </div>

                <!-- Precios -->
                <div *ngIf="usuario" class="price-section mb-3 p-3 border rounded bg-light">
                  <!-- Cuotas -->
                  <div class="d-flex justify-content-between align-items-center text-muted small mb-2">
                    <span title="Pago con tarjeta en cuotas">
                      <i class="fas fa-credit-card text-warning me-1"></i> Cuotas
                    </span>
                    <strong>${{ (item.precioLis * cotizacion) | number:'1.2-2' }}</strong>
                  </div>

                  <!-- Efectivo -->
                  <div class="d-flex justify-content-between align-items-center text-success small mb-2">
                    <span title="Pago en efectivo">
                      <i class="fas fa-money-bill-wave me-1"></i> Contado
                    </span>
                    <strong>${{ (item.precioCon * cotizacion) | number:'1.2-2' }}</strong>
                  </div>

                  <!-- Ahorro -->
                  <div class="d-flex justify-content-between align-items-center text-danger small">
                    <span title="Diferencia entre precio de lista y pago en efectivo">
                      <i class="fas fa-piggy-bank me-1"></i> Ahorrás
                    </span>
                    <span class="fw-bold">
                      ${{ ((item.precioLis - item.precioCon) * cotizacion) | number:'1.2-2' }}
                      ({{ (((item.precioLis - item.precioCon) / item.precioLis * 100)*cotizacion) | number:'1.0-0' }}%)
                    </span>
                  </div>
                </div>



                <div class="row">
                  <div class="col-4 pr-1">
                    <button class="btn btn-outline-primary btn-block" (click)="openModal(item)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                  </div>
                  <div class="col-4 pl-1">
                    <button class="btn btn-warning btn-block" (click)="addItem(item)" [disabled]="item.stock <= 0"
                      [attr.aria-disabled]="item.stock <= 0">
                      <i class="fas fa-cart-plus"></i>
                      {{ item.stock > 0 ? '' : 'Sin stock' }}
                    </button>
                  </div>
                  <div class="col-4 pl-1">
                    <button class="btn btn-block btn-success" (click)="shareProduct(item)">
                      <i class="fas fa-share-alt"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </ng-template>

      <!-- Pagination -->
      <nav class="mt-4">
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="prevPage <= 0">
            <a class="page-link" (click)="setPage(prevPage)" href="javascript:void(0)">&laquo;</a>
          </li>
          <li class="page-item disabled">
            <span class="page-link">Página {{ page }} de {{ lastPage }}</span>
          </li>
          <li class="page-item" [class.disabled]="page === lastPage">
            <a class="page-link" (click)="setPage(nextPage)" href="javascript:void(0)">&raquo;</a>
          </li>
        </ul>
      </nav>
    </section>

  </div>
  <app-marcas [marcas]="conf?.marcas"></app-marcas>
  <app-footer [conf]="conf"></app-footer>

</div>